import { useQuery } from '@tanstack/react-query';
import { getProfile } from '../api/users';

export const PROFILE_QUERY_KEY = ['profile'];

const staleTime = 5 * 60 * 1000;

export default function useProfile() {
  const query = useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: getProfile,
    staleTime,
    refetchOnWindowFocus: false
  });

  return {
    profile: query.data || null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch
  };
}
